'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ProductStatusText } from '@eliadmin/core/src/components/product/product-status-text';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductAccordion } from './product-accordion';
import { Paragraph } from '../../../ui/paragraph';
import Image from 'next/image';
import { IoIosCloseCircleOutline } from 'react-icons/io';

export function ProductAccordionParameters() {
  const { t } = useTranslations();
  const product = useVariantsStore(s => s.product);
  const selectedVariant = useVariantsStore(s => s.selectedVariant);

  const parameters = [
    {
      id: 1,
      label: `${t('text511')}:`,
      value: selectedVariant?.width ?? product?.width,
    },
    {
      id: 2,
      label: `${t('text512')}:`,
      value: selectedVariant?.length ?? product?.length,
    },
    {
      id: 3,
      label: `${t('text513')}:`,
      value: selectedVariant?.height ?? product?.height,
    },
    {
      id: 4,
      label: `${t('text237')}`,
      value: selectedVariant?.availability?.name ?? product?.availability.name,
    },
    {
      id: 5,
      label: `${t('text228')}`,
      value: selectedVariant?.code ?? product?.code,
    },
  ];

  const availability = selectedVariant?.availability ?? product?.availability;
  const hasSpecialProductStatus = product.status === 'ended' || product.status === 'arrival';

  return (
    <div className="flex w-full flex-col items-start justify-start gap-2 sm:gap-3">
      {parameters.map(parameter => (
        <div key={parameter.label} className="grid w-full grid-cols-2 gap-2">
          <Paragraph color="muted-foreground" className="col-span-1 w-full">
            {parameter.label}
          </Paragraph>
          <Paragraph
            color="black"
            className="col-span-1 flex w-full items-center justify-end gap-2 text-right"
          >
            {parameter.id === 4 &&
              (availability?.id === 1 ? (
                <Image
                  src={'/images/icons/available.svg'}
                  alt={availability?.name}
                  width={20}
                  height={20}
                  className="shrink-0 object-contain"
                />
              ) : (
                <IoIosCloseCircleOutline size={20} className="text-[#9B2929]" />
              ))}
            {parameter.id === 4 && hasSpecialProductStatus ? (
              <ProductStatusText status={product.status} sizeClassName="text-sm" />
            ) : (
              (parameter.value ?? '-')
            )}
          </Paragraph>
        </div>
      ))}
    </div>
  );
}
